import React from 'react'
import { Button } from 'semantic-ui-react'
import { MainArticleLayout } from '../../../layouts/MainArticleLayout'
import EnquiryService from '../../../services/EnquiryService'
import { useHistory } from 'react-router-dom'

const EnquiryClose = () => {
  const queryParams = new URLSearchParams(location.search)
  const history = useHistory()

  const cancelClose = () => {
    history.push('/my-account/enquiries')
  }
  const closeEnquiry = async () => {
    return await EnquiryService.closeEnquiry(queryParams.get('id')).then(
      (response) => {
        if (response.result) {
          history.push('/my-account/enquiries')
        }
      }
    )
  }
  return (
    <>
      <MainArticleLayout>
         <h2>Close your enquiry?</h2>
        
        <p>
        Your enquiry will be closed and you&apos;ll need to start a new enquiry to get help from us.
        </p>

       
        <p>
        You&apos;ll still be able to view the closed enquiry and the information we gave you in <b>My account – Enquiries</b>.
        </p>
        <p></p>
        <p></p>
        <Button
          type="button"
          className="ui button is-secondary"
          onClick={cancelClose}
        >
          Cancel
        </Button>
        <Button className="ui is-primary button" onClick={closeEnquiry}>
          Close enquiry
        </Button>
      </MainArticleLayout>
    </>
  )
}
export default EnquiryClose
